import Phaser from 'phaser';
import { store } from '../state/store';
import { COLORS } from '../ui/theme';

// Patterns categorize manifest keys into asset classes so each loads at an
// appropriate resolution. Backgrounds and the legacy nextarrow SVG are skipped
// — backgrounds are solid colors now, and the arrow is drawn with Graphics.
const SKIP_KEY = (key: string): boolean =>
  key.startsWith('bg-') || key === 'nextarrow-arrow1-a';

// SVGs rasterize once at load; a scale multiplier keeps the source aspect
// ratio intact (explicit width+height would distort). Scratch art is authored
// at 480×360-stage scale, so 2.5–3× gives crisp textures at our 1280×960.
const scaleFor = (key: string): number => {
  if (key.startsWith('baker-')) return 3;
  if (key.startsWith('oven-closed') || key.startsWith('oven-open')) return 2.5;
  if (key.startsWith('loader-')) return 1.5;
  return 2.5;
};

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Preload' });
  }

  preload(): void {
    const { manifest } = store;
    const cx = this.scale.width / 2;
    const cy = this.scale.height / 2;

    this.add.text(cx, cy - 80, 'BAKERY PRO', {
      fontFamily: '"Fredoka", "Trebuchet MS", sans-serif',
      fontSize: '54px',
      fontStyle: '700',
      color: '#f7901e',
    }).setOrigin(0.5);

    const barWidth = 480;
    const barHeight = 28;
    const barX = cx - barWidth / 2;
    const barY = cy + 20;
    this.add.rectangle(cx, barY + barHeight / 2, barWidth, barHeight, COLORS.headerPurpleDeep)
      .setStrokeStyle(2, COLORS.white);
    const fill = this.add.rectangle(barX + 2, barY + 2, 0, barHeight - 4, COLORS.accentOrange).setOrigin(0, 0);

    this.load.on('progress', (p: number) => {
      fill.width = (barWidth - 4) * p;
    });

    for (const [key, path] of Object.entries(manifest.images)) {
      if (SKIP_KEY(key)) continue;
      if (path.endsWith('.png')) {
        this.load.image(key, path);
      } else {
        this.load.svg(key, path, { scale: scaleFor(key) });
      }
    }
    // Audio deferred to Phase 5; the existing manifest also has two
    // unsupported files that flood the console with decode errors.
  }

  create(): void {
    this.scene.start('Welcome');
  }
}
